import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center overflow-hidden" style={{
    background: 'radial-gradient(ellipse at top, #F5F8FF 0%, #EEF2FF 60%, #E0E7FF 100%)'
  }} data-id="element-164">
      {/* Soft pastel glows — desktop only */}
      <div className="absolute top-10 left-1/4 w-[380px] h-[380px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(96, 165, 250, 0.30)'
    }} data-id="element-165"></div>
      <div className="absolute bottom-10 right-1/4 w-[340px] h-[340px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(251, 191, 36, 0.25)'
    }} data-id="element-166"></div>

      {/* Attention Badge */}
      <div className="relative bg-white border border-[#DBEAFE] text-[#1D4ED8] font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2 shadow-sm" data-id="element-167">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-[#EF4444] animate-pulse" data-id="element-168"></span>
        <span className="hidden sm:inline" data-id="element-169">
          🧮 ATENCIÓN: DOCENTES DE MATEMÁTICAS CANSADOS DE SACRIFICAR SUS NOCHES
          PLANIFICANDO
        </span>
        <span className="sm:hidden" data-id="element-170">ATENCIÓN: DOCENTES DE MATEMÁTICAS</span>
      </div>

      {/* Main headline */}
      <h1 className="relative font-black max-w-5xl text-[26px] leading-[1.15] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-4 sm:mb-6 tracking-tight" style={{
      color: '#1E293B'
    }} data-id="element-171">
        Resuelve todo tu año de clases de Matemáticas en{' '}
        <span className="text-transparent bg-clip-text" style={{
        backgroundImage: 'linear-gradient(90deg, #2563EB 0%, #F59E0B 100%)'
      }} data-id="element-172">
          solo 5 minutos.
        </span>
      </h1>

      {/* Mockup image — LCP element */}
      <div className="relative w-full max-w-[340px] sm:max-w-[520px] md:max-w-[640px] mx-auto mb-4 sm:mb-8" data-id="element-173">
        <div className="absolute inset-0 blur-[50px] rounded-full hidden sm:block" style={{
        background: 'rgba(96, 165, 250, 0.25)'
      }} data-id="element-174"></div>
        <img src="https://cdn.magicpatterns.com/uploads/ebnaz7hiPmdc8TiCBWyoEd/Diseno-sin-titulo-_54_.webp" alt="MegaPack Matemática Lista™ — 6 Tomos para Primaria / Educación Básica" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(37,99,235,0.20)]" width={1080} height={900} sizes="(min-width: 768px) 640px, (min-width: 640px) 520px, 340px" fetchPriority="high" loading="eager" decoding="async" data-id="element-175" />
      </div>

      {/* Subheadline */}
      <p className="relative sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-white/70 sm:backdrop-blur-sm sm:border sm:border-[#DBEAFE] sm:border-l-4 sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left sm:shadow-sm text-[14px]" style={{
      color: '#475569',
      borderLeftColor: '#2563EB'
    }} data-id="element-176">
        Fichas, ejercicios y evaluaciones para toda la{' '}
        <span className="font-bold" style={{
        color: '#2563EB'
      }} data-id="element-177">
          Primaria/Básica (todos los años)
        </span>{' '}
        — listos para{' '}
        <span className="font-semibold" style={{
        color: '#1E293B'
      }} data-id="element-178">
          imprimir, proyectar o usar en tablet
        </span>{' '}
        mañana mismo.
      </p>

      {/* Stars + Urgency */}
      <div className="relative flex flex-col items-center gap-2 mb-4 sm:mb-6" data-id="element-179">
        <div className="flex items-center gap-2" data-id="element-180">
          <span className="text-sm sm:text-lg" style={{
          color: '#F59E0B'
        }} data-id="element-181">
            ⭐⭐⭐⭐⭐
          </span>
          <span className="text-xs sm:text-base font-medium" style={{
          color: '#475569'
        }} data-id="element-182">
            4.9/5 (+1,200 Reseñas Verificadas)
          </span>
        </div>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white" style={{
      backgroundColor: '#22C55E'
    }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#16A34A'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#22C55E'} data-id="element-183">
        🚀 ¡SÍ! RESOLVER MI AÑO DE MATEMÁTICAS YA
      </a>

      {/* Trust badges */}
      <p className="relative text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" style={{
      color: '#475569'
    }} data-id="element-184">
        <span data-id="element-185">⚡ Acceso Inmediato</span>
        <span data-id="element-186">•</span>
        <span data-id="element-187">🛡️ Garantía 7 Días</span>
        <span data-id="element-188">•</span>
        <span data-id="element-189">💳 Pago Único</span>
      </p>
    </section>;
}